import { Card, CardDescription, CardTitle } from "@conlit/ui";
import { useLocation } from "react-router";
import { useLocale } from "@/features/localisation/locale-context";

const thaiTitles: Record<string, string> = {
  "Learning module": "บทเรียน",
  "Branching scenario": "สถานการณ์จำลอง",
  Flashcards: "บัตรคำ",
  Reflection: "การสะท้อนความคิด",
  "Content library": "คลังเนื้อหา",
  Assessments: "แบบทดสอบ",
  Questions: "คำถาม",
  Scenarios: "สถานการณ์จำลอง",
  "Pseudonymised datasets": "ชุดข้อมูลนามแฝง",
  "Research analytics": "การวิเคราะห์งานวิจัย",
  "Research exports": "การส่งออกข้อมูลงานวิจัย",
  Organisations: "องค์กร",
  Users: "ผู้ใช้งาน",
  "Content governance": "การกำกับดูแลเนื้อหา",
  "Audit logs": "บันทึกการตรวจสอบ",
};

export function PlaceholderPage({ title }: { title: string }) {
  const location = useLocation();
  const { locale } = useLocale();
  const displayTitle = locale === "th" ? (thaiTitles[title] ?? title) : title;
  return (
    <Card>
      <p className="text-participation text-sm font-semibold">
        {locale === "th" ? "พื้นที่เตรียมพัฒนา" : "Foundation route"}
      </p>
      <CardTitle className="mt-2">{displayTitle}</CardTitle>
      <CardDescription>
        {locale === "th"
          ? "พื้นที่นี้เตรียมไว้สำหรับการพัฒนาฟีเจอร์ในขั้นถัดไป"
          : "This workspace is ready for feature implementation. Its production data access will use feature-owned TanStack Query hooks and Supabase RLS."}
      </CardDescription>
      <code className="rounded-control bg-surface-disabled mt-6 block p-3 text-sm">
        {location.pathname}
      </code>
    </Card>
  );
}
